import { render, staticRenderFns } from "./modalVincular.vue?vue&type=template&id=00527892"
import script from "./modalVincular.vue?vue&type=script&lang=js"
export * from "./modalVincular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports